import { Component } from "react";
import { TableColumn } from "react-data-table-component";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { ApprovalTwoTone } from '@mui/icons-material';
import { RemoveCircleTwoTone } from '@mui/icons-material';


import './ReviewExpenseProof.css';
import { loadFromLocalStorage } from "../../Common/Validation/LocalStorage";
import DataGrid from "../../Components/DataGrid/DataGrid";
import ProfileServices from "../../Services/ProfileServices";
import ExpenseService from "../../Services/ExpenseService";
import { amountFormat } from "../../Components/helper";
import { ShowAlert } from "../../Components/ShowAlert";
import CustomMaterialMenu from "../../Components/DataGrid/Plugins/CustomMaterialMenu/CustomMaterialMenu";
const MySwal = withReactContent(Swal);




export interface IProof {
    fileName: string,
    fileId: string,
    size: string,
    fileStatus: string,
    comments: string
    error?: string
}

export interface IQuestion {

    questionId: string,
    response: any,
    question: string,
    questionOrder: number,
    status: string,
    files: IProof[]
}

export interface IUserListOfPendingReview {
    userId: string,
    userName: string,
    email: string,
    mobileNumber: string,
    questions: IQuestion[],
    fileStatus: 'Approved' | 'Rejected' | 'Pending'
}

interface IQuestionProps {
    questions: IQuestion[];
    userId: string;
    userName: string;
    accessToken: string;
    onPopupClose?: () => void
}
interface IQuestionState {
    questions: IQuestion[];
    //activeQuestionId?: string;

}

export interface IReviewExpenseProofsState {
    userlist: IUserListOfPendingReview[],
    accessToken: string;
    currentPage: number,
    currentRowsPerPage: number,
    searchText: string,
    totalRows: number,
    currentSortColumn: string,
    sortingDirection: string
}

class Questions extends Component<IQuestionProps, IQuestionState> {

    constructor(props: IQuestionProps) {
        super(props);
        this.state = {
            questions: this.props.questions
        }
    }

    private questionColumns: TableColumn<IQuestion>[] = [
        {
            name: 'Question',
            selector: row => row.question, maxWidth: '300px',
            sortable: true
        },
        {
            name: 'Answer',
            sortable: true,
            selector: (row: IQuestion) => amountFormat(row.response, 'en-US', 'USD'),

            maxWidth: '200px',
            right: true,


        },
        {
            name: 'Status',
            sortable: true,
            selector: (row: IQuestion) => row.status,
            cell: (row: IQuestion) => (
                <span className={`status-badge ${row.status.toLowerCase()}`}>
                    {row.status}
                </span>
            ),
            maxWidth: '200px',

        },
        {
            name: 'Documents',
            cell: (row: IQuestion) => (
                <button
                    className='view-documents-btn'
                    onClick={(event) => {
                        this.viewDocuments(row);
                    }}>
                    View Documents ({row.files.length})
                </button>
            ),
            allowOverflow: false,
            button: true,
            width: '200px'
        },
        {
            name: 'Files to Review',
            selector: (row: IQuestion) => row.files.filter(x => x.fileStatus && x.fileStatus.toLowerCase() == "pending").length,
            allowOverflow: false,
            button: true,
            right: true,
            width: '200px'
        },
          
    ];

    viewDocuments(row: IQuestion) {

        MySwal.fire({
            title: `Documents for ${this.props.userName}`,
            html: this.renderDocumentTableWithActions(row),
            showCloseButton: true,
            showConfirmButton: false,
            width: '900px',
            customClass: {
                popup: 'document-popup'
            },
            didClose: () => {

                console.log('Popup closed');
                if (this.props.onPopupClose) {
                    this.props.onPopupClose(); //  trigger parent

                }
            }
        });
    }




    renderDocumentTableWithActions(row: IQuestion) {
        const isDisabled = row.status === 'Rejected' || row.status === 'Approved';

        if (!row.files || row.files.length === 0) {
            return (
                <div style={{ textAlign: 'center' }}>
                    <p>No documents available for this user.</p>
                </div>
            );
        }

        return (
            <div className="table-container">
                <div
                    className="status-container"
                >
                    <p className="status-text">
                        <strong>Question:</strong>{' '}
                        <span className="status-text">{row.question}</span>
                    </p>
                    <p className="status-text">
                        <strong>Answer:</strong>{' '}
                        <span className="status-text">{amountFormat(row.response, 'en-US', 'USD')}</span>
                    </p>
                </div>

                <table style={{ width: '100%', borderCollapse: 'collapse', marginTop: '20px' }}>
                    <thead>
                        <tr style={{ backgroundColor: '#f5f5f5' }}>
                            <th className="expense-val-table-cell expense-val-table-header">Serial No</th>
                            <th className="expense-val-table-cell expense-val-table-header">Proof Document</th>
                            <th className="expense-val-table-cell expense-val-table-header">Comments</th>
                            <th className="expense-val-table-cell expense-val-table-header" style={{ width: '35%' }}>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {row.files.map((doc, index) => (
                            <tr key={index}>
                                <td className="expense-val-table-cell">{index + 1}</td>
                                <td className="expense-val-table-cell">
                                    {doc ? (
                                        <p
                                            className="expense-proof-file"
                                            onClick={(event) => {
                                                event.preventDefault();
                                                this.downloadFile(doc.fileId, doc.fileName);
                                            }}
                                        >
                                            {doc.fileName}
                                        </p>
                                    ) : (
                                        '-'
                                    )}
                                </td>
                                <td>
                                    <textarea placeholder="Enter rejection comment..."
                                        rows={3}
                                        cols={40}
                                        style={{
                                            resize: 'none',
                                            borderRadius: '5px',
                                            border: doc.error ? '1px solid #f16262ff' : '1px solid #ccc',
                                            padding: '5px',
                                            fontSize: '14px',
                                            width: '100%'
                                        }} value={doc.comments} disabled={doc.fileStatus == 'Rejected'}
                                        onChange={(e) => {
                                            doc.comments = e.target.value;
                                            if (e.target.value.trim().length > 0) {
                                                doc.error = ''; // clear error on typing
                                            }
                                            this.forceUpdate();
                                        }} />


                                    {doc.error && (
                                        <div style={{ color: 'red', fontSize: '12px', marginTop: '2px' }}>
                                            {doc.error}
                                        </div>)}
                                </td>
                                <td className="expense-val-table-cell">
                                    {this.approveOrRejectFile(doc, row.question)}

                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        );

    }

    approveOrRejectFile(file: IProof, question: string) {
        const isDisabled = file.fileStatus === 'Rejected' || file.fileStatus === 'Approved';
        return <div className="approve-reject-button-container">
            <button
                id="popup-approve-btn"
                className={isDisabled ? 'approve-reject-button approve-btn-color disabled' : 'approve-reject-button approve-btn-color'}
                onClick={() => {

                    this.approveOrReject(file, file.comments, true, question);
                }}
                disabled={isDisabled}
            >
                Approve
            </button>

            {/* <button
                id="popup-reject-btn"
                className={isDisabled ? 'approve-reject-button reject-btn-color disabled' : 'approve-reject-button reject-btn-color'}

                onClick={() => {

                }}
                disabled={isDisabled}
            >
                Reject
            </button> */}

            <button
                id="popup-reject-btn"
                className={
                    isDisabled
                        ? 'approve-reject-button reject-btn-color disabled'
                        : 'approve-reject-button reject-btn-color'
                }
                onClick={() => {

                    this.approveOrReject(file, file.comments, false, question);
                }}
                disabled={isDisabled}
            >
                Reject
            </button>


        </div>

    }

    downloadFile(fileId: string, fileName: string) {
        const downloadData = {
            fileId: fileId,
            fileName: fileName
        };

        ExpenseService.downloadExpenseProof(downloadData, this.props.accessToken).then((response) => {
            if (response.ok) {
                response.json().then(data => {

                    // Handle different response formats
                    let base64Data = data.body;

                    if (base64Data && typeof base64Data === 'string') {
                        try {
                            ///... Clean the base64 string - remove any whitespace and ensure it's properly formatted
                            base64Data = base64Data.replace(/\s/g, '');

                            ///... Convert base64 to blob
                            const byteCharacters = atob(base64Data);
                            const byteNumbers = new Array(byteCharacters.length);
                            for (let i = 0; i < byteCharacters.length; i++) {
                                byteNumbers[i] = byteCharacters.charCodeAt(i);
                            }
                            const byteArray = new Uint8Array(byteNumbers);
                            const blob = new Blob([byteArray], { type: 'application/pdf' });


                            // Create blob link to download
                            const url = window.URL.createObjectURL(blob);
                            const link = document.createElement('a');
                            link.href = url;
                            link.download = fileName;

                            // Append to html link element page
                            document.body.appendChild(link);

                            // Start download
                            link.click();

                            // Clean up and remove the link
                            link.parentNode?.removeChild(link);
                            window.URL.revokeObjectURL(url);

                        } catch (error) {

                        }
                    } else {

                    }
                });
            } else {

            }
        }).catch((err: any) => {

        });
    }

    approveOrReject(file: IProof, comment: string, approvalStatus: boolean, question: string) {
        if (!comment && !approvalStatus) {
            alert('Please add rejection comments');
            return;
        }
        let payload = {
            fileId: file.fileId,
            comment: comment,
            approvalStatus: approvalStatus ? 'Approved' : 'Rejected',
            userId: this.props.userId,
            question: question
        }

        ExpenseService.updateFileReviewStatus(payload, this.props.accessToken).then(r => {
            r.json().then(resp => {
                let msg = `Expense proof ${file.fileName} of user ${this.props.userName} is ${approvalStatus ? 'Approved' : 'Rejected'}.`
                ShowAlert(`Documents status updated`, msg, 'success').then(() => {
                    if (this.props.onPopupClose) {
                        this.props.onPopupClose();
                    }
                });

            }).catch(ex => {
                let msg = `Expense proof ${file.fileName} of user ${this.props.userName} is failed to ${approvalStatus ? 'Approve' : 'Rejecte'}.`
                ShowAlert(`Documents status updated`, msg, 'failure').then(() => {
                    if (this.props.onPopupClose) {
                        this.props.onPopupClose();
                    }
                })
            })
        })
    }



    render() {
        return (
            <DataGrid
                title='Questions'
                columns={this.questionColumns}
                data={this.state.questions}
                pagination
                paginationTotalRows={this.props.questions?.length}
            />
        );
    }

}



class ReviewExpenseProofs extends Component<{}, IReviewExpenseProofsState> {
    constructor(props: any) {
        super(props);
        this.state = {
            userlist: [],
            accessToken: '',
            currentPage: 1,
            currentRowsPerPage: 10,
            searchText: '',
            totalRows: 0,
            currentSortColumn: '',
            sortingDirection: ''
        }
    }

    private formColumns: TableColumn<IUserListOfPendingReview>[] = [
        {
            name: 'Taxpayer Name',
            selector: (row: IUserListOfPendingReview) => row.userName,
            width: '150',
            sortable: true
        },
        {
            name: 'Email',
            selector: (row: IUserListOfPendingReview) => row.email,
            sortable: true,
            // width: '175px',
        },
        {
            name: 'Mobile Number',
            selector: (row: IUserListOfPendingReview) => row.mobileNumber,
            sortable: true,
            maxWidth: '150px'
        },
        {
            name: 'Pending Questions',
            selector: (row: IUserListOfPendingReview) => row.questions.filter(x => x.status.toLowerCase() != "approved").length,
            maxWidth: '150px',
            right: true,
        },
        {
            name: 'Status',
            cell: (row: IUserListOfPendingReview) => (
                <span className={`status-badge ${row.fileStatus.toLowerCase()}`}>
                    {this.getUserReviewStatus(row.questions)}
                </span>
            ),
            maxWidth: '150px',
        },
    ];

    async componentDidMount() {
        ///... check token in local storage
        const accesstoken = await loadFromLocalStorage('accessToken');
        ///... if available get user details otherwise re-direct to login page
        if (accesstoken) {
            this.setState({
                accessToken: accesstoken.toString()
            }, () => {
                ///... real API Call
                this.getPendingUserList();
            });
        }
        else {
            localStorage.clear();
            window.location.href = '/'
        }
    }


    getPendingUserList() {
        let postData = {
            sort: {
                column: this.state.currentSortColumn,
                direction: this.state.sortingDirection
            },
            limit: this.state.currentRowsPerPage,
            offset: (this.state.currentPage - 1) * this.state.currentRowsPerPage,
            searchFilter: this.state.searchText
        };
        ExpenseService.getUserListPendingForReview(postData, this.state.accessToken).then(r => {
            if (r.ok) {
                r.json().then(response => {
                    this.setState({ userlist: response.data, totalRows: response.totalCount });
                })
            }
        });
    }

    getUserReviewStatus(questions: IQuestion[]) {
        try {
            return questions.some(x => x.status.toLowerCase() == 'pending') ? "Pending" :
                questions.some(x => x.status.toLowerCase() == 'rejected') ? "Rejected" : "Approved";
        }
        catch (ex) {
            alert('Something went wrong');
        }
    }

    identifySortingMapColumn(columnName: string) {
        let actualColName = '';
        switch (columnName) {
            case "Taxpayer Name":
                actualColName = 'userName';
                break;
            case "Email":
                actualColName = 'email';
                break;
            case "Mobile Number":
                actualColName = 'mobileNumber';
                break;
            case "Status":
                actualColName = 'status';
                break;
        }
        return actualColName;
    }


    public render() {

        const ExpandedComponent = ({ data }: { data: IUserListOfPendingReview }) => (
            <div style={{ padding: '10px', background: '#f9f9f9' }}>
                <Questions userId={data.userId} userName={data.userName} questions={data.questions} accessToken={this.state.accessToken} onPopupClose={() => {
                    this.getPendingUserList(); // 👈 refresh or update state here
                }} />
            </div>
        );
        return <div className='body-sub-contianer table-container'>
            <DataGrid
                title='Expense Proof Review'
                search='User Details'
                columns={this.formColumns}
                data={this.state.userlist}
                onSearch={(searchText_: string) => {
                    this.setState({
                        searchText: searchText_,
                        currentPage: 1
                    }, () => {
                        ///... api call
                        this.getPendingUserList();
                    })
                }}

                onChangeRowsPerPage={(currentRowsPerPage, currentPage) => {
                    this.setState({
                        currentPage: currentPage,
                        currentRowsPerPage: currentRowsPerPage
                    }, () => {
                        ///... api call
                        this.getPendingUserList();
                    })
                }}
                onChangePage={(page: number, totalRows: number) => {
                    console.log(page, totalRows);
                    this.setState({
                        currentPage: page
                    }, () => {
                        ///... api call
                        this.getPendingUserList();
                    })
                }}
                onSort={(column: any, direction) => {

                    this.setState({
                        currentSortColumn: this.identifySortingMapColumn(column.name),
                        sortingDirection: direction,
                        currentPage: 1
                    }, () => {
                        ///... api call
                        this.getPendingUserList();
                    })
                }}
                expandableRows
                expandedComponent={ExpandedComponent}
                pagination
                paginationTotalRows={this.state.totalRows}
            />
        </div>
    }
}
export default ReviewExpenseProofs;